import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import moment from 'moment';

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { EdgeApi } from '@trialcard/apigateway.client';
import  CommonTools  from '../components/tools/commonTools';

import LayoutModule from './layout';
import EnrollmentModule from './enrollment';
import { Settings } from '~/services/settings';

import { Field } from '~/types/docuSign/Fields';

@InjectModule({ stateFactory: true }, module)
export default class DocusignModule extends InjectVuexModule {
    @Resolve
    settings!: Settings;

    @Resolve
    layout!: LayoutModule;

    @Resolve
    edgeApi!: EdgeApi;

    envelopeId = '';
    recipientViewURL = '';
    eventType: string | null = null;

    selectTemplate() {
        const language =  'English';
        const templateId = this.settings.templateId
        return templateId as string;
    }

    selectBrandId() {

        const brandId = this.settings.brandId;
        return brandId as string;
    }





    @Action({})
    async createEnvelope(payload:any) {
        let isSuccessful = false;

        try {
            const axios: AxiosInstance = (this.edgeApi as any).axios;
            const axiosRequest: AxiosRequestConfig = {
                url: 'edge/signature/v1/EmailSignatureTemplate/CreateEnvelope',
                method: 'POST',
                data: payload,
                headers: {
                    'x-program-id': this.settings.programId!,
                },
            };
            console.log( (this.edgeApi as any).authentications)
            await Promise.all([
                // (this.edgeApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
                // (this.edgeApi as any).authentications.Bearer.applyToRequest(axiosRequest),
                 (this.edgeApi as any).authentications.Token.applyToRequest(axiosRequest),
            ]);
            const { data } = await axios.request(axiosRequest);
            const envelopeId = data && data.data && data.data.envelopeId || '';
            if (!envelopeId) throw new Error('Envelope creation failed')
            this.setEnvelopeId(envelopeId);
            isSuccessful = data.data && data.success;
        } catch(error) {
            console.error('Error from creating Docusign envelope:',error);
        }
        return isSuccessful
    }

    @Action({})
    async requestURL(payload:any) {
        let isSuccessful = false;
        try {
            const axios: AxiosInstance = (this.edgeApi as any).axios;
            const axiosRequest: AxiosRequestConfig = {
                url: 'edge/signature/v1/RecipientView/RequestURL',
                method: 'POST',
                data: payload,
                headers: {
                    'x-program-id': this.settings.programId!,
                },
            };
            console.log( (this.edgeApi as any).authentications)
            await Promise.all([
                // (this.edgeApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
                // (this.edgeApi as any).authentications.Bearer.applyToRequest(axiosRequest),
                (this.edgeApi as any).authentications.Token.applyToRequest(axiosRequest),
            ]);
            const { data } = await axios.request(axiosRequest);
          const recipientViewURL = data && data.data && data.data.url || '';
            if (!recipientViewURL) throw new Error('Getting URL failed')
            console.log(recipientViewURL)
             this.setRecipientViewURL(recipientViewURL);
             console.log(recipientViewURL)
            isSuccessful = data.data && data.success;

        } catch(error) {
            console.error('Error from requesting recipient view URL:',error);
        }
        return isSuccessful;
    }

    @Mutation
    setEnvelopeId(envelopeId: string) {
        this.envelopeId = envelopeId;
    }

    @Mutation
    setRecipientViewURL(recipientViewURL: string) {
        this.recipientViewURL = recipientViewURL;
    }

    @Mutation
    setEventType(eventType: string | null) {
        this.eventType = eventType;
    }

}
